
import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import {
  Elements,
  useStripe,
  useElements,
  CardElement,
} from '@stripe/react-stripe-js';
import { jwtDecode } from 'jwt-decode';
import '../Styles/StripePayment.css';

// ✅ Stripe public key
const stripePromise = loadStripe(
  'pk_live_51PI8HpP97ZTk6krE6ErmShZYcskqZCD2uxKvCHNKHpKQpOYqJBIQFx7ybtBdqLCoe7TM7rO9gRW5iSEq3Icgtdtz00l02KwBce'
);

// ✅ Checkout form component
const CheckoutForm = ({ clientSecret, amount, agencyId, onSuccess }) => {
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    const result = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: elements.getElement(CardElement),
      },
    });

    if (result.error) {
      alert(result.error.message);
    } else if (result.paymentIntent.status === 'succeeded') {
      alert('✅ Payment Successful!');

      // Call backend to update wallet
      await fetch('https://b2bdubaibackendapi.mmstourism.com/api/b2/payment/updateWalletAfterPayment', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          agencyId,
          amount,
          stripeReference: result.paymentIntent.id,
        }),
      });

      onSuccess();
    }
  };
const CARD_OPTIONS = {
  style: {
    base: {
      fontSize: '16px',
      color: '#32325d',
      fontFamily: 'Segoe UI, sans-serif',
      '::placeholder': { color: '#a0aec0' },
    },
    invalid: {
      color: '#fa755a',
    },
  },
  // 🚫 Disable autofill / saved cards
  disableLink: true, 
  hidePostalCode: true,
};

return(
<form 
  onSubmit={handleSubmit} 
  className="payment-form" 
  autoComplete="off"
>
  <CardElement className="card-element" options={CARD_OPTIONS} />
  <button type="submit" disabled={!stripe} className="pay-button">
    Pay Now
  </button>
</form>
);

  // return (
  //   <form onSubmit={handleSubmit} className="payment-form">
  //     <CardElement className="card-element" />
  //     <button type="submit" disabled={!stripe} className="pay-button">
  //       Pay Now
  //     </button>
  //   </form>
  // );
};

// ✅ Main payment component
const StripePayment = () => {
  const [amount, setAmount] = useState('');
  const [clientSecret, setClientSecret] = useState(null);
  const [loading, setLoading] = useState(false);
  const [paymentDone, setPaymentDone] = useState(false);

  // // ✅ Get agencyId from token
  // let agencyId = null;
  // try {
  //   const token = localStorage.getItem('b2bAuthToken');
  //   if (token) {
  //     const decoded = jwtDecode(token);
  //     agencyId = decoded.id; // 🟢 Make sure backend sends `id` as `agencyId`
  //   }
  // } catch (err) {
  //   console.error('Failed to decode token:', err);
  // }


let agencyId = null;
try {
  const stored = localStorage.getItem('b2bAuthToken');
  if (stored) {
    const parsed = JSON.parse(stored); // Parse the JSON object
    const token = parsed.token; // Extract the actual JWT token string
    const decoded = jwtDecode(token); // Decode it
    agencyId = decoded.id; // Adjust field name as per your token payload (e.g. id, _id, agencyId)
    console.log("Decoded agencyId:", agencyId);
  }
} catch (err) {
  console.error('Error decoding token:', err);
}

  const createPaymentIntent = async () => {
    if (!amount || isNaN(amount) || parseFloat(amount) <= 0) {
      alert('Please enter a valid amount in AED.');
      return;
    }

    if (!agencyId) {
      alert('User session expired or agencyId not found.');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch('https://b2bdubaibackendapi.mmstourism.com/api/b2/payment/createPayment', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          amount: parseFloat(amount),
          currency: 'aed',
          agencyId,
        }),
      });

      const data = await response.json();
      setClientSecret(data.clientSecret);
    } catch (error) {
      console.error('Payment intent error:', error);
      alert('Error creating payment. Try again.');
    }
    setLoading(false);
  };

  const resetForm = () => {
    setAmount('');
    setClientSecret(null);
    setPaymentDone(true);
    setTimeout(() => setPaymentDone(false), 4000);
  };

  const appearance = { theme: 'stripe' };
  const options = { clientSecret, appearance };

  return (
    <div className="payment-container">
      {paymentDone && <div className="success-message">🎉 Wallet updated successfully!</div>}

      {!clientSecret ? (
        <>
          <h2 className="title">Pay with Card</h2>
          <input
            type="number"
            placeholder="Enter amount in AED"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            className="amount-input"
          />
          <button onClick={createPaymentIntent} disabled={loading} className="start-button">
            {loading ? 'Creating Payment...' : 'Proceed to Pay'}
          </button>
        </>
      ) : (
        <Elements stripe={stripePromise} options={options}>
          <CheckoutForm
            clientSecret={clientSecret}
            amount={parseFloat(amount)}
            agencyId={agencyId}
            onSuccess={resetForm}
          />
        </Elements>
      )}
    </div>
  );
};

export default StripePayment;
